__turbopack_context__.v({
  "allAwarded": "status-badge-module-scss-module__JT6NgG__allAwarded",
  "dot": "status-badge-module-scss-module__JT6NgG__dot",
  "ended": "status-badge-module-scss-module__JT6NgG__ended",
  "label": "status-badge-module-scss-module__JT6NgG__label",
  "live": "status-badge-module-scss-module__JT6NgG__live",
  "live-dot-glow": "status-badge-module-scss-module__JT6NgG__live-dot-glow",
  "live-text-glow": "status-badge-module-scss-module__JT6NgG__live-text-glow",
  "root": "status-badge-module-scss-module__JT6NgG__root",
  "sizeLg": "status-badge-module-scss-module__JT6NgG__sizeLg",
  "sizeMd": "status-badge-module-scss-module__JT6NgG__sizeMd",
  "sizeResponsive": "status-badge-module-scss-module__JT6NgG__sizeResponsive",
  "sizeSm": "status-badge-module-scss-module__JT6NgG__sizeSm",
  "upcoming": "status-badge-module-scss-module__JT6NgG__upcoming",
});
